import React, { useState } from "react";
import { Box, Grid, Divider, List, Link } from "@mui/material";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import meta from "../../../Assets/img/socials/meta.png";
import linkedin from "../../../Assets/img/socials/linkedin.png";
import twitter from "../../../Assets/img/socials/x.png";
import youtube from "../../../Assets/img/socials/youtube.png";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import { enqueueSnackbar } from "notistack";
import logo from "../../../Assets/img/logodetails.png";
import dayjs from "dayjs";
import { CorrectState } from "./MapList";
import { useScrollToHash } from "../../../Hooks/useScrollToHash";
import NewMap from "./NewMap";
import { getSummaryDescription, formatLocation } from "../../../Functions/formatters";

function Summary({ summaryData, id }) {
  const [isViewEmail, setIsViewEmail] = useState({});
  const [isViewEmail1, setIsViewEmail1] = useState({});

  const textStyles = "text-[#004878] text-md ";

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "" || isNaN(value)) {
      return "-";
    }
    return parseFloat(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const renderParagraphPair = (label, text) => (
    <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
      <ParagraphComp
        text={label}
        className={`${textStyles} w-[130px] font-bold`}
      />
      <ParagraphComp text={text} className={`${textStyles} font-normal`} />
    </Box>
  );

  const renderSocial = (icon, title, link) => (
    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
      <img
        src={icon}
        className="w-[25px] h-[25px]"
        style={{ borderRadius: "50%" }}
        alt="socials"
      />
      <Link href={link} target="_blank">
        {title || "-"}
      </Link>
    </Box>
  );

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useScrollToHash();

  const token = localStorage.getItem("NpoToken");
  const dataUserToken = localStorage.getItem("dataUserAccessToken");

  const viewEmail = (email) => {
    if (token || dataUserToken) {
      setIsViewEmail((prev) => ({
        ...isViewEmail,
        [email]: prev[email] ? false : true,
      }));
    } else {
      enqueueSnackbar("Please register or log in to view email", {
        variant: "error",
      });
    }
  };

  const viewEmail1 = (email) => {
    if (token || dataUserToken) {
      setIsViewEmail1((prev) => ({
        ...isViewEmail1,
        [email]: prev[email] ? false : true,
      }));
    } else {
      enqueueSnackbar("Please register or log in to view email", {
        variant: "error",
      });
    }
  };

  const convertEmail = (email) => {
    return email.replace(/@/g, "(at)").replace(/\./g, "[dot]");
  };

  const scrollToSection = () => {
    document.getElementById("involved")?.scrollIntoView({ behavior: "smooth" });
  };

  const appearSeals = [
    "Platinum",
    "Silver",
    "Bronze",
    "Bronze under review for higher certification",
    "Gold",
  ];

  // Safe data object – falls back to empty object if summaryData is null/undefined
  const data = summaryData || {};

  React.useEffect(() => {
    if (summaryData && Object.keys(summaryData).length > 0) {
      const whatWeDoSentence = getSummaryDescription(data);

      console.log("[NPO Profile - What We Do Section]:", {
        orgName: data?.org_name,
        fullConstructedText: whatWeDoSentence,
        formattedLocation: formatLocation(data?.where_we_work_district),
        rawBackendFields: {
          registration_year: data?.registration_year,
          total_lives_changed: data?.total_lives_changed,
          segment_served: data?.segment_served,
          causes: data?.causes,
          where_we_work_district: data?.where_we_work_district,
          where_we_work_states: data?.where_we_work_states,
          pan_india: data?.pan_india,
          key_indicator: data?.key_indicator,
          verified: data?.verified,
          end_goal: data?.end_goal,
          end_goal_year: data?.end_goal_year,
        },
      });
    }
  }, [summaryData]);

  const registrationData = Array.isArray(data?.registration_as)
    ? data.registration_as
    : [data?.registration_as].filter(Boolean);

  // Helper to check if a section has any non‑empty data
  const hasData = (fields) => {
    if (!data || typeof data !== "object") return false;
    return fields.some((field) => {
      const val = data[field];
      return (
        val !== undefined &&
        val !== null &&
        val !== "" &&
        !(Array.isArray(val) && val.length === 0)
      );
    });
  };

  return (
    <div id={id}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={9}>
          <Box sx={{ marginBottom: "30px" }}>
            <Grid
              sx={{
                height: "40px",
                backgroundColor: "#004878",
                marginBottom: "0px",
                justifyContent: "space-around",
                display: "flex",
                gap: "20px",
                alignItems: "center",
                borderRadius: "10px",
              }}
            >
              <ParagraphComp
                onClick={() => handleScroll("Causes")}
                text="Summary"
                className="text-[white] max-sm:text-[10px] hover:underline hover:text-[#dedada] transition-[2s] cursor-pointer text-xl font-normal"
              />
              <ParagraphComp
                onClick={() => handleScroll("ProgramsAndResults")}
                text="Programmes & Results"
                className="text-[white] max-sm:text-[10px] hover:text-[#dedada] hover:underline transition-[2s] cursor-pointer text-xl font-normal"
              />
              <ParagraphComp
                onClick={() => handleScroll("Governance")}
                text="Governance"
                className="text-[white] cursor-pointer max-sm:text-[10px] hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal"
              />
              <ParagraphComp
                onClick={() => handleScroll("Financial")}
                text="Financials"
                className="text-[white] cursor-pointer max-sm:text-[10px] hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal"
              />
              <ParagraphComp
                onClick={() => handleScroll("Operations")}
                text="Operations"
                className="text-[white] cursor-pointer max-sm:text-[10px] hover:text-[#dedada] hover:underline transition-[2s] text-xl font-normal"
              />
              <ParagraphComp
                onClick={scrollToSection}
                text="Get Involved"
                className="text-[white] cursor-pointer hover:text-[#dedada] max-sm:text-[10px] hover:underline transition-[2s] text-xl font-normal"
              />
            </Grid>
            <Grid container xs={12}>
              <Grid xs={12} md={6} lg={6}>
                <ParagraphComp
                  text="*SOURCE: Self-reported by organisation"
                  className="text-[black] font-light text-md italic  "
                />
              </Grid>
              <Grid xs={12} md={6} lg={6}>
                <ParagraphComp
                  text="Last updated on:"
                  className="text-[black] font-light text-md italic  "
                />
              </Grid>
            </Grid>
          </Box>

          {/* ====== BASIC INFO ====== */}
          <Grid container spacing={2} xs={12}>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  height: "200px",
                  borderRadius: "8px",
                }}
              >
                {data?.logo ? (
                  <img
                    src={`data:image/png;base64,${data.logo}`}
                    alt="logo"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <img
                    src={logo}
                    alt="logo"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} lg={9}>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Also known as:"
                  className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold"
                />
                <ParagraphComp
                  text={data?.also_known_as || "-"}
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Formerly known as:"
                  className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold"
                />
                <ParagraphComp
                  text={data?.former_name || "-"}
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold">
                  City/ Town/ Taluka/ Village, District, <br />
                  State of Main Office :
                </ParagraphComp>
                <ParagraphComp
                  text={`${data?.city || "-"}, ${data?.district || "-"}, ${data?.state || "-"}`}
                  className="text-[#004878] max-sm:w-[50%] w-[70%] max-sm:text-[14px] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Works pan India:"
                  className="text-[#004878] w-[30%] max-sm:w-[50%] text-md max-sm:text-[14px] font-bold"
                />
                <ParagraphComp
                  text={data?.pan_india || "-"}
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Registered as:"
                  className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold"
                />
                <ParagraphComp
                  text={
                    registrationData.length
                      ? registrationData.map((item) => item.sub_data).join(", ")
                      : "-"
                  }
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Registered in the year:"
                  className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold"
                />
                <ParagraphComp
                  text={data?.registration_year || "-"}
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                <ParagraphComp
                  text="Slogan/ Tag line:"
                  className="text-[#004878] max-sm:text-[14px] w-[30%] max-sm:w-[50%] text-md font-bold"
                />
                <ParagraphComp
                  text={data?.slogan || "-"}
                  className="text-[#004878] max-sm:text-[14px] w-[70%] max-sm:w-[50%] text-md font-normal"
                />
              </Box>
            </Grid>
          </Grid>

          <Box>
            <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
              <ParagraphComp
                text="Profile Last Updated by NPO"
                className="text-[#004878] w-[20%] max-sm:w-[100px] max-sm:text-[12px] text-md font-bold"
              />
              <ParagraphComp
                text={
                  data?.last_updated_date
                    ? dayjs(data.last_updated_date).format("DD-MM-YYYY")
                    : "-"
                }
                className="text-[#004878] w-[80%] max-sm:text-[12px] text-md font-normal"
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
              <ParagraphComp
                text="Get Involved"
                className="text-[#d0353c] text-md w-[20%] max-sm:w-[100px] max-sm:text-[12px] font-bold cursor-pointer"
                onClick={scrollToSection}
              />
              <ParagraphComp
                text={data?.get_involved || "-"}
                className="text-[#004878] w-[80%] max-sm:text-[12px] text-md font-normal"
              />
            </Box>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ display: "flex", gap: 1, mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text={`Expenditure in FY ${data?.annual_expenditure_fy || ""}:`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={`₹ ${formatAmount(data?.annual_expenditure)}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
                <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                  <ParagraphComp
                    text="Total full-time paid Staff:"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={data?.full_time_paid_staff || "-"}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ display: "flex", gap: 1, mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text={`Assets as of FY ${data?.assets_fy || ""}:`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={`₹ ${formatAmount(data?.assets)}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
                <Box sx={{ display: "flex", gap: 2, mb: 0.5 }}>
                  <ParagraphComp
                    text="Total full-time pro-bono Volunteers:"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={data?.pro_brono_volunteers || "-"}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ display: "flex", gap: 2, mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text="Lives / entities impacted so for:"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={data?.total_lives_changed || "-"}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text={`Tax Exemption under ${data?.exemption_type || "-"}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={`Valid till: ${data?.exemption_valid_till || "-"}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text={`Deduction to Indian taxpayers under ${data?.deduction_type || "-"}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={`Valid till: ${data?.deduction_valid_till || "-"}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text="Eligibility to receive foreign contributions"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={`Valid till: ${data?.foreign_valid_till || "-"}`}
                    className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} lg={4}>
                <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
                <Box sx={{ mb: 0.5, mt: 1.5 }}>
                  <ParagraphComp
                    text="Organisation is registered with Ministry of Corporate Affairs for CSR"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold"
                  />
                  <ParagraphComp
                    text={data?.csr_fund_registration || "-"}
                    className="text-[#004878] text-md max-sm:text-[14px] font-normal"
                  />
                </Box>
              </Grid>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                  marginTop: "20px",
                  color: "#E5E8EB",
                  borderBottomWidth: 3,
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <ParagraphComp
                  text="SOURCE: Self-reported by organisation"
                  className="text-[black] italic max-sm:text-[14px] text-md font-thin"
                />
                <ParagraphComp
                  text="Please check the respective government site for eligibility and validity as on date."
                  className="text-[black] max-sm:text-[14px] italic text-md font-thin"
                />
              </Box>
              <Box sx={{ marginTop: "20px" }} />
            </Grid>
          </Box>
        </Grid>

        {/* ====== RIGHT SIDEBAR: TRUST & TRANSPARENCY ====== */}
        <Grid
          item
          sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
          xs={12}
          md={3}
          lg={3}
        >
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "16px",
              border: "1px solid grey",
              padding: "16px",
            }}
          >
            <HeaderCompo
              className="text-2xl font-bold text-[#004878] text-center"
              tagType="h3"
              text="Trust and Transparency Indicator"
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {data?.trust_and_transparency_level === "Claim your profile" ? (
                <Link href="/register-npo">
                  <img
                    src={`data:image/png;base64,${data?.trust_and_transparency_logo}`}
                    width={242}
                    height={211}
                    style={{ borderRadius: 12 }}
                    alt="logo"
                  />
                </Link>
              ) : (
                data?.trust_and_transparency_logo && (
                  <img
                    src={`data:image/png;base64,${data.trust_and_transparency_logo}`}
                    width={242}
                    height={211}
                    style={{ borderRadius: 12 }}
                    alt="logo"
                  />
                )
              )}
            </Box>
            {appearSeals.includes(data?.trust_and_transparency_level) && (
              <Box sx={{ display: "flex", gap: 2, mb: 0.5, mt: 3 }}>
                <Box sx={{ width: "25%" }}>
                  <ParagraphComp
                    text="Valid till"
                    className="text-[#004878] max-sm:text-[14px] text-md font-bold w-30"
                  />
                </Box>
                <ParagraphComp
                  text={`: ${data?.level !== "Basic" || "Entry" ? dayjs(data?.valid_till).format("DD-MM-YYYY") : "-"}`}
                  className="text-[#004878] max-sm:text-[14px] text-md font-normal"
                />
              </Box>
            )}
            {appearSeals.includes(data?.trust_and_transparency_level) &&
              data?.provisional !== "No" && (
                <Box sx={{ display: "flex", gap: 2, mb: 0.5, mt: 3 }}>
                  <Box sx={{ width: "25%" }}>
                    <ParagraphComp
                      text="Provisional"
                      className="text-[#004878] text-md font-bold w-30"
                    />
                  </Box>
                  <ParagraphComp
                    text={`: ${data?.provisional || "-"}`}
                    className="text-[#004878] text-md font-normal"
                  />
                </Box>
              )}
            {data?.remarks && (
              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                <Box sx={{ width: "25%" }}>
                  <ParagraphComp
                    text="Remarks"
                    className="text-[#004878] text-md font-bold"
                  />
                </Box>
                <Box sx={{ display: "flex", width: "70%", gap: "2px" }}>
                  <ParagraphComp
                    text=":"
                    className="text-[#004878] text-md font-normal"
                  />
                  <ParagraphComp
                    text={data.remarks || "-"}
                    className="text-[#004878] text-md font-normal"
                  />
                </Box>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              backgroundColor: "#EDF2F6",
              borderRadius: "16px",
              padding: "16px",
            }}
          >
            <ParagraphComp
              text="Certification History"
              className="text-[#004878] text-lg max-sm:text-[14px] font-bold"
            />
            {data?.certification_history?.length > 0 ? (
              data.certification_history
                .sort((a, b) => {
                  const [startA] = a?.financial_year_under_review
                    ?.split("-")
                    .map(Number);
                  const [startB] = b?.financial_year_under_review
                    ?.split("-")
                    .map(Number);
                  return startA - startB;
                })
                .map((history, index) => (
                  <Box className="flex mt-[20px] max-sm:mt-[10px]" key={index}>
                    {history?.financial_year_under_review ||
                    history?.certification_level_awarded ? (
                      <>
                        <ParagraphComp
                          text={history?.financial_year_under_review || "-"}
                          className="text-[#004878] text-md font-bold w-[80px] flex-shrink-0"
                        />
                        <Box className="flex gap-[10px] max-sm:gap-[5px]">
                          <ParagraphComp
                            text=":"
                            className="text-[#004878] text-md font-normal"
                          />
                          <ParagraphComp
                            text={history?.certification_level_awarded || "-"}
                            className="text-[#004878] text-md font-normal"
                          />
                        </Box>
                      </>
                    ) : (
                      "-"
                    )}
                  </Box>
                ))
            ) : (
              <ParagraphComp
                text="-"
                className="text-[#004878] text-md font-bold w-40"
              />
            )}
          </Box>
        </Grid>

        {/* ====== CAUSES SECTION ====== */}
        <Grid item xs={12} id="Causes">
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} lg={6}>
              <Box
                sx={{
                  backgroundColor: "#004878",
                  padding: "10px",
                  borderRadius: "15px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ParagraphComp
                  text="Summary"
                  className="text-[white] mt-[0px] mb-[0px] text-2xl font-bold"
                />
              </Box>
            </Grid>
          </Grid>
          <Grid
            sx={{
              marginTop: "30px",
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
            }}
            xs={12}
          >
            <Grid xs={12} lg={5.85} md={5.85} sx={{ height: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <ParagraphComp
                  text="Causes"
                  className="text-[#004878] leading-tight text-md font-bold"
                />
                <ParagraphComp
                  text="(based on international classification of NPOs)"
                  className="text-[#004878] text-md font-normal mt-[2px]"
                />
                {data?.causes?.length > 0 ? (
                  <List>
                    {data.causes.map((item, index) => (
                      <ParagraphComp
                        key={index}
                        text={
                          item.data
                            ? `${index + 1}. ${item.data
                                .split(/,\s*(?=[A-Z])/)
                                .join(", ")}`
                            : ""
                        }
                        className="text-[#004878] text-md"
                      />
                    ))}
                  </List>
                ) : (
                  <ParagraphComp
                    text="No causes reported."
                    className="text-[#004878] text-md"
                  />
                )}
              </Box>
            </Grid>

            <Grid xs={12} lg={5.85} md={5.85} sx={{ height: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <ParagraphComp
                  text="Work towards UN Sustainable Development Goals"
                  className="text-[#004878] text-md font-bold"
                />
                {data?.sustainable_developement ? (
                  <List>
                    {data.sustainable_developement.includes(",") ? (
                      data.sustainable_developement
                        .split(", ")
                        .map((item, i) => (
                          <ParagraphComp
                            key={i}
                            text={`${i + 1}. ${item}`}
                            className="text-[#004878] text-md"
                          />
                        ))
                    ) : (
                      <ParagraphComp
                        text={`1. ${data.sustainable_developement}`}
                        className="text-[#004878] text-md"
                      />
                    )}
                  </List>
                ) : (
                  <ParagraphComp
                    text="No SDGs reported."
                    className="text-[#004878] text-md"
                  />
                )}
              </Box>
            </Grid>

            <Grid xs={12} lg={5.85} md={5.85} sx={{ height: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <ParagraphComp
                  text="Nature of Intervention"
                  className="text-[#004878] text-md font-bold"
                />
                {data?.nature_of_intervention ? (
                  <List>
                    {data.nature_of_intervention.split(/,\s*(?=[A-Z])/).length > 1 ? (
                      data.nature_of_intervention
                        .split(/,\s*(?=[A-Z])/)
                        .map((item, i) => (
                          <ParagraphComp
                            key={i}
                            text={`${i + 1}. ${item.trim()}`}
                            className="text-[#004878] text-md"
                          />
                        ))
                    ) : (
                      <ParagraphComp
                        text={`1. ${data.nature_of_intervention}`}
                        className="text-[#004878] text-md"
                      />
                    )}
                  </List>
                ) : (
                  <ParagraphComp
                    text="No intervention data."
                    className="text-[#004878] text-md"
                  />
                )}
              </Box>
            </Grid>

            <Grid xs={12} lg={5.85} md={5.85} sx={{ height: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <ParagraphComp
                  text="Populations / Segments Served"
                  className="text-[#004878] text-md font-bold"
                />
                {data?.segment_served ? (
                  <List>
                    {data.segment_served.split(/,\s*(?=[A-Z])/).length > 1 ? (
                      data.segment_served
                        .split(/,\s*(?=[A-Z])/)
                        .map((item, i) => (
                          <ParagraphComp
                            key={i}
                            text={`${i + 1}. ${item.trim()}`}
                            className="text-[#004878] text-md"
                          />
                        ))
                    ) : (
                      <ParagraphComp
                        text={`1. ${data.segment_served}`}
                        className="text-[#004878] text-md"
                      />
                    )}
                  </List>
                ) : (
                  <ParagraphComp
                    text="No segments reported."
                    className="text-[#004878] text-md"
                  />
                )}
              </Box>
            </Grid>
          </Grid>

          {/* ====== CONTACT INFO ====== */}
          <Grid container xs={12} spacing={2} sx={{ marginTop: "30px" }}>
            <Grid item xs={12} lg={4} sx={{ height: "auto" }}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <ParagraphComp
                  text="Organisation Contact Information"
                  className="text-[#004878] text-md font-bold"
                />
                <Box sx={{ display: "flex", mt: 2 }}>
                  <ParagraphComp
                    text="Website"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  {data?.website_url ? (
                    <a
                      href={data.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#004878] text-md font-normal"
                    >
                      : {data.website_url}
                    </a>
                  ) : (
                    <ParagraphComp
                      text=": -"
                      className="text-[#004878] text-md font-normal"
                    />
                  )}
                </Box>
                <Box sx={{ display: "flex", mt: 1 }}>
                  <ParagraphComp
                    text="Email Id"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <Box sx={{ display: "flex", gap: "4px" }}>
                    <ParagraphComp
                      text=": "
                      className="text-[#004878] cursor-pointer text-md font-normal"
                    />
                    <ParagraphComp
                      onClick={() => viewEmail(data?.primary_email)}
                      text={
                        data?.primary_email
                          ? isViewEmail?.[data.primary_email]
                            ? convertEmail(data.primary_email)
                            : "View"
                          : "-"
                      }
                      className="text-[#004878] cursor-pointer underline text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 1 }}>
                  <ParagraphComp
                    text="Contact Number"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {Array.isArray(data?.contact_number) &&
                    data.contact_number.length > 0 ? (
                      data.contact_number.map((contact, index) => (
                        <ParagraphComp
                          key={index}
                          text={`: ${contact?.country_code.startsWith("+") ? contact.country_code : `+${contact.country_code}` || "-"}-${contact.area_code ? `${contact.area_code}-` : ""}${contact.phone_no || "-"}`}
                          className="text-[#004878] text-md font-normal"
                        />
                      ))
                    ) : (
                      <ParagraphComp
                        text=": -"
                        className="text-[#004878] text-md font-normal"
                      />
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "150px" }}>
                    <ParagraphComp
                      text="Head Of Organization"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <ParagraphComp
                      text={`: ${data?.head_of_organisation || "-"}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>

                <ParagraphComp
                  text="Contact Person's Details"
                  className="text-[#004878] text-md font-bold mt-3"
                />
                <Box sx={{ display: "flex", mt: 1 }}>
                  <ParagraphComp
                    text="Name"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <ParagraphComp
                    text={`: ${data?.contact_person_name || "-"}`}
                    className="text-[#004878] text-md font-normal"
                  />
                </Box>
                <Box sx={{ display: "flex", mt: 0.5 }}>
                  <ParagraphComp
                    text="Email Id"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <Box sx={{ display: "flex", gap: "4px" }}>
                    <ParagraphComp
                      text=": "
                      className="text-[#004878] cursor-pointer text-md font-normal"
                    />
                    <ParagraphComp
                      onClick={() => viewEmail1(data?.contact_person_email)}
                      text={
                        data?.contact_person_email
                          ? isViewEmail1?.[data.contact_person_email]
                            ? convertEmail(data.contact_person_email)
                            : "View"
                          : "-"
                      }
                      className="text-[#004878] cursor-pointer underline text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 0.5 }}>
                  <ParagraphComp
                    text="Phone"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <ParagraphComp
                    text={`: ${data?.contact_person_telephone ? `${data?.telephone_country_code ? (data.telephone_country_code.split(" ")[0].startsWith("+") ? `${data.telephone_country_code.split(" ")[0]}-` : `+${data.telephone_country_code.split(" ")[0]}-`) : ""}${data?.telephone_area_code ? ` ${data.telephone_area_code}` : ""}${data?.telephone_area_code ? "-" : ""}${data.contact_person_telephone}` : "-"}`}
                    className="text-[#004878] text-md font-normal"
                  />
                </Box>
                <Box sx={{ display: "flex", mt: 0.5 }}>
                  <ParagraphComp
                    text="Mobile Number"
                    className="text-[#004878] text-md font-bold w-40"
                  />
                  <ParagraphComp
                    text={`: ${data?.contact_person_mobile_no ? `${data?.mobile_country_code ? (data.mobile_country_code.split(" ")[0].startsWith("+") ? `${data.mobile_country_code.split(" ")[0]}-` : `+${data.mobile_country_code.split(" ")[0]}-`) : ""} ${data.contact_person_mobile_no}` : "-"}`}
                    className="text-[#004878] text-md font-normal"
                  />
                </Box>
              </Box>
            </Grid>

            <Grid sx={{ height: "auto" }} item xs={12} lg={5}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "35%" }}>
                    <ParagraphComp
                      text="PAN"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "60%" }}>
                    <ParagraphComp
                      text={`: ${data?.pan || "-"}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "35%" }}>
                    <ParagraphComp
                      text="Darpan ID"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "65%" }}>
                    <ParagraphComp
                      text={`: ${data?.darpan || "-"}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "35%" }}>
                    <ParagraphComp
                      text="FCRA Registration No"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "65%" }}>
                    <ParagraphComp
                      text={`: ${data?.foreign_fund_number || "-"}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "35%" }}>
                    <ParagraphComp
                      text="Registered Address"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "65%" }}>
                    <ParagraphComp
                      text={`: ${data?.reg_room_no ? `${data.reg_room_no.replace(/,\s*$/, "")},` : ""} ${data?.reg_street ? `${data.reg_street.replace(/,\s*$/, "")},` : ""} ${data?.reg_city ? `${data.reg_city.replace(/,\s*$/, "")},` : ""} ${data?.reg_district ? `${data.reg_district.replace(/,\s*$/, "")},` : ""} ${data?.reg_state ? `${data.reg_state.replace(/,\s*$/, "")},` : ""} ${data?.reg_pincode ? `${data.reg_pincode.replace(/,\s*$/, "")}` : ""}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Box sx={{ width: "35%" }}>
                    <ParagraphComp
                      text="Correspondence Address"
                      className="text-[#004878] text-md font-bold"
                    />
                  </Box>
                  <Box sx={{ width: "65%" }}>
                    <ParagraphComp
                      text={`: ${data?.cor_room_no ? `${data.cor_room_no.replace(/,\s*$/, "")},` : ""} ${data?.cor_street ? `${data.cor_street.replace(/,\s*$/, "")},` : ""} ${data?.cor_city ? `${data.cor_city.replace(/,\s*$/, "")},` : ""} ${data?.cor_district ? `${data.cor_district.replace(/,\s*$/, "")},` : ""} ${data?.cor_state ? `${data.cor_state.replace(/,\s*$/, "")},` : ""} ${data?.cor_pincode ? `${data.cor_pincode.replace(/,\s*$/, "")}` : ""}`}
                      className="text-[#004878] text-md font-normal"
                    />
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid sx={{ height: "auto" }} item xs={12} lg={3}>
              <Box
                sx={{
                  backgroundColor: "#EDF2F6",
                  borderRadius: "16px",
                  padding: "16px",
                  height: "100%",
                }}
              >
                {renderSocial(
                  meta,
                  "Facebook/ Instagram",
                  data?.social_media_facebook,
                )}
                {renderSocial(
                  linkedin,
                  "LinkedIn",
                  data?.social_media_linkedin,
                )}
                {renderSocial(twitter, "Twitter", data?.social_media_twitter)}
                {renderSocial(youtube, "Youtube", data?.social_media_youtube)}
              </Box>
            </Grid>
          </Grid>

          {/* ====== FUTURE / AIM / DO ====== */}
          {data?.future_we_envision && (
            <Box sx={{ mt: 7, width: "100%" }}>
              <ParagraphComp
                text="What is the future we envision"
                className="text-[#004878] text-2xl mb-2 font-bold"
              />
              <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
              <ParagraphComp
                text={data.future_we_envision}
                className="text-md mt-2 text-black text-justify"
              />
            </Box>
          )}

          {data?.aim_to_solve && (
            <Box sx={{ mt: 3, width: "100%" }}>
              <ParagraphComp
                text="What we aim to solve"
                className="text-[#004878] text-2xl mb-2 font-bold"
              />
              <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
              <ParagraphComp
                text={data.aim_to_solve}
                className="text-md mt-2 text-black text-justify"
              />
            </Box>
          )}

          <Box sx={{ mt: 3, width: "100%" }}>
            <ParagraphComp
              text="What we do"
              className="text-[#004878] text-2xl mb-2 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            {data?.registration_year ||
            data?.segment_served ||
            data?.causes?.length ? (
              <ParagraphComp
                text={getSummaryDescription(data)}
                className="text-md mt-2 text-black text-justify"
              />
            ) : (
              <ParagraphComp
                text="No description available."
                className="text-md mt-2 text-black"
              />
            )}
          </Box>

          {data?.leaders_quotes && data.leaders_quotes !== "undefined" && (
            <Box sx={{ mt: 3, width: "100%" }}>
              <ParagraphComp
                text="Leader’s Quote"
                className="text-[#004878] text-2xl mb-2 font-bold"
              />
              <div className="flex gap-1">
                <ParagraphComp
                  text="Leader's Name"
                  className="text-[#004878] text-md mb-2 font-bold"
                />
                <ParagraphComp
                  text={data?.leader_name || "-"}
                  className="text-[#004878] text-md mb-2"
                />
              </div>
              <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
              <ParagraphComp
                text={data.leaders_quotes}
                className="text-md mt-2 text-black text-justify"
              />
            </Box>
          )}

          {data?.history && (
            <Box
              sx={{
                mt: 3,
                width: "100%",
                backgroundColor: "#EFF1F3",
                borderRadius: "16px",
                padding: "16px",
                ml: -2,
                mr: 0,
              }}
            >
              <ParagraphComp
                text="Why and how was the organisation set up"
                className="text-[#004878] text-2xl mb-2 font-bold"
              />
              <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
              <ParagraphComp
                text={data.history}
                className="text-md mt-2 text-black text-justify"
              />
            </Box>
          )}
        </Grid>
      </Grid>

      {/* ====== WHERE WE WORK / SEE WHAT WE DO ====== */}
      <Grid container spacing={2} sx={{ mt: 4 }}>
        <Grid item xs={12} lg={6} md={6}>
          <Box sx={{ width: "100%" }}>
            <ParagraphComp
              text="Where we work"
              className="text-[#004878] text-2xl mb-2 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            <Box className="mt-2 flex gap-2 max-sm:flex-col max-sm:gap-[0px]">
              <Box sx={{ position: "relative", height: "420px", width: "70%" }}>
                <NewMap
                  selectedState={CorrectState(data?.where_we_work_states)}
                  PanIndia={data?.pan_india === "Yes"}
                />
                <Box
                  className="max-sm:bottom-[20px]!important bottom-0"
                  sx={{
                    position: "absolute",
                    width: "100%",
                    margin: "auto",
                    backgroundColor: "white",
                    zIndex: 50,
                  }}
                >
                  <ParagraphComp
                    text="Disclaimer: Map of India may not be to scale and is only for illustration purposes."
                    className="text-[#004878] text-sm"
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 5,
                  paddingTop: "40px",
                }}
              >
                <Box>
                  <ParagraphComp
                    text="Works pan India:"
                    className="text-[#004878] text-md mb-1 font-bold"
                  />
                  <ParagraphComp
                    text={data?.pan_india || "-"}
                    className="text-[#004878] text-md"
                  />
                </Box>
                <Box>
                  <ParagraphComp
                    text="Key State(s):"
                    className="text-[#004878] text-md mb-1 font-bold"
                  />
                  {data?.where_we_work_states ? (
                    data.where_we_work_states.includes(",") ? (
                      data.where_we_work_states
                        .split(",")
                        .map((item, i) => (
                          <ParagraphComp
                            key={i}
                            text={item}
                            className="text-[#004878] text-md"
                          />
                        ))
                    ) : (
                      <ParagraphComp
                        text={data.where_we_work_states}
                        className="text-[#004878] text-md"
                      />
                    )
                  ) : (
                    <ParagraphComp
                      text="-"
                      className="text-[#004878] text-md"
                    />
                  )}
                </Box>
                <Box>
                  <ParagraphComp
                    text="Geographical focus:"
                    className="text-[#004878] text-md mb-1 font-bold"
                  />
                  {data?.geographical_focus_of_activity ? (
                    data.geographical_focus_of_activity.includes(",") ? (
                      data.geographical_focus_of_activity
                        .split(", ")
                        .map((item, i) => (
                          <ParagraphComp
                            key={i}
                            text={item}
                            className="text-[#004878] text-md"
                          />
                        ))
                    ) : (
                      <ParagraphComp
                        text={data.geographical_focus_of_activity}
                        className="text-[#004878] text-md"
                      />
                    )
                  ) : (
                    <ParagraphComp
                      text="-"
                      className="text-[#004878] text-md"
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={6} md={6}>
          <ParagraphComp
            text="See what we do"
            className="text-[#004878] text-2xl mb-2 font-bold"
          />
          <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
          <ParagraphComp
            text="One picture that tells the story of what the organisation does"
            className="text-md mt-2 mb-2 text-black"
          />
          {data?.story ? (
            <img
              src={`data:image/png;base64,${data.story}`}
              className="h-[300px] max-h-[300px] object-cover max-w-[100%]"
              style={{ borderRadius: 12 }}
              alt="story"
            />
          ) : (
            <ParagraphComp
              text="No image provided."
              className="text-md mt-2 text-black"
            />
          )}
        </Grid>
      </Grid>

      {/* ====== CAPABILITIES & CHALLENGES ====== */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} lg={6} md={6}>
          <Box sx={{ width: "100%" }}>
            <ParagraphComp
              text="Organisation’s Capabilities & Advantages"
              className="text-[#004878] text-2xl mb-2 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            <ParagraphComp
              text={data?.organisation_capabilities || "-"}
              className="text-md mt-2 text-black text-justify"
            />
          </Box>
        </Grid>
        <Grid item xs={12} lg={6} md={6}>
          <Box sx={{ width: "100%" }}>
            <ParagraphComp
              text="Challenges"
              className="text-[#004878] text-2xl mb-2 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            <ParagraphComp
              text={data?.challenges || "-"}
              className="text-md mt-2 text-black"
            />
          </Box>
        </Grid>
      </Grid>

      {/* ====== GET INVOLVED ====== */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} id="involved">
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#EDF2F6",
              borderRadius: "16px",
              padding: "16px",
            }}
          >
            <Box sx={{ display: "flex", gap: "4px" }}>
              <ParagraphComp
                text="Get Involved - "
                className="text-[#d0353c] text-2xl font-bold cursor-pointer"
              />
              <ParagraphComp
                text=" How you can make a difference"
                className="text-[#004878] text-2xl mb-2 font-bold"
              />
            </Box>
            <ParagraphComp
              text="*SOURCE: Self-reported by the organisation"
              className="text-[black] italic font-thin text-md"
            />
            <ParagraphComp
              text="Last updated on:"
              className="text-[black] font-bold text-md"
            />

            {data?.trust_and_transparency_level !== "Claim your profile" ? (
              <Grid container spacing={2} xs={12}>
                {/* Give money */}
                {data?.trust_and_transparency_level !== "Entry Level" && (
                  <Grid
                    className="max-sm:border-none border-r-[1px] border-black"
                    item
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                    xs={12}
                    lg={4}
                    md={4}
                  >
                    <Box
                      className="flex"
                      sx={{ alignItems: "start", gap: 1, mt: 2 }}
                    >
                      <Box
                        sx={{
                          height: "70px",
                          borderRadius: "100%",
                          width: "70px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "white",
                          flexShrink: 0,
                        }}
                      >
                        {data?.give_money_icon ? (
                          <img
                            src={`data:image/png;base64,${data.give_money_icon}`}
                            width={48}
                            height={48}
                            style={{ flexShrink: 0 }}
                            alt="give money icon"
                          />
                        ) : null}
                      </Box>
                      <Box>
                        <ParagraphComp
                          text="Give money"
                          className="text-[#004878] text-2xl font-bold"
                        />
                        <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                          <span>
                            Put to use your precious funds to address needs
                            identified by the organisation!
                          </span>{" "}
                          <br />
                          <span>
                            What we need: {data?.make_a_difference || "-"}
                          </span>{" "}
                          <br />
                          {data?.give_money_email ? (
                            <span>
                              To support {data?.give_money_program_name}
                              {data?.give_money_webpage ? (
                                <a
                                  href={data.give_money_webpage}
                                  className="text-[#0697e6] cursor-pointer"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {" "}
                                  click here{" "}
                                </a>
                              ) : (
                                ""
                              )}
                              {data?.give_money_email ? "or" : ""}
                              {data?.give_money_email ? (
                                <a
                                  href={`mailto:${data.give_money_email}`}
                                  className="text-[#0697e6] cursor-pointer"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {" "}
                                  email
                                </a>
                              ) : (
                                ""
                              )}
                            </span>
                          ) : (
                            <span></span>
                          )}
                        </ParagraphComp>
                      </Box>
                    </Box>
                  </Grid>
                )}

                {/* Volunteer */}
                {data?.trust_and_transparency_level !== "Entry Level" && (
                  <Grid
                    item
                    className="max-sm:border-none border-r-[1px] border-black"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                    xs={12}
                    lg={4}
                    md={4}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "start",
                        gap: 1,
                        mt: 2,
                      }}
                    >
                      <Box
                        sx={{
                          height: "70px",
                          borderRadius: "100%",
                          width: "70px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "white",
                          flexShrink: 0,
                        }}
                      >
                        {data?.volunteer_icon ? (
                          <img
                            src={`data:image/png;base64,${data.volunteer_icon}`}
                            width={48}
                            height={48}
                            alt="volunteer icon"
                          />
                        ) : null}
                      </Box>
                      <Box sx={{ width: "70%", color: "#004878" }}>
                        <ParagraphComp
                          text="Volunteer"
                          className="text-[#004878] text-2xl text-md font-bold"
                        />
                        <ParagraphComp
                          text="Give your time and talent to engage with the cause or community you care about!"
                          className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal"
                        />
                        <span>
                          Opportunity(ies): {data?.volunteer_cause || "-"}
                        </span>{" "}
                        <br />
                        {data?.volunteer_email && (
                          <ParagraphComp className="text-lg max-sm:text-[14px] text-[#004878]">
                            <ParagraphComp
                              text={`Give your talent and time for a ${data?.volunteer_cause}.`}
                              className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal"
                            />
                            To learn more,
                            {data?.volunteer_webpage ? (
                              <a
                                href={data.volunteer_webpage}
                                className="text-[#0697e6] cursor-pointer"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                click here{" "}
                              </a>
                            ) : (
                              ""
                            )}
                            {data?.volunteer_email ? "or" : ""}
                            {data?.volunteer_email ? (
                              <a
                                href={`mailto:${data.volunteer_email}`}
                                className="text-[#0697e6] cursor-pointer"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                email
                              </a>
                            ) : (
                              ""
                            )}
                          </ParagraphComp>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                )}

                {/* Gift in-kind */}
                <Grid
                  item
                  className="max-sm:border-none border-r-[1px] border-black"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                  xs={12}
                  lg={4}
                  md={4}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Box
                      sx={{
                        height: "70px",
                        borderRadius: "100%",
                        width: "70px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        flexShrink: 0,
                      }}
                    >
                      {data?.gift_in_kind_icon ? (
                        <img
                          src={`data:image/png;base64,${data.gift_in_kind_icon}`}
                          width={48}
                          height={48}
                          alt="gift in kind icon"
                        />
                      ) : null}
                    </Box>
                    <Box sx={{ width: "70%", color: "#004878" }}>
                      <ParagraphComp
                        text="Gift in-kind"
                        className="text-[#004878] text-2xl font-bold"
                      />
                      <ParagraphComp
                        text="Gift articles of NPO’s need. You may buy new ones or gift pre-used articles in good condition."
                        className="text-md mt-2 text-[#004878] leading-normal"
                      />
                      <span>
                        Item(s) needed:{" "}
                        {Array.isArray(data?.items)
                          ? data.items
                              .map(
                                (ele) => `${ele?.category} - ${ele?.products}`,
                              )
                              .join(", ")
                          : "-"}
                      </span>{" "}
                      <br />
                      {data?.gift_in_kind_email && (
                        <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                          To make your gift,
                          {data?.gift_in_kind_webpage ? (
                            <a
                              href={data.gift_in_kind_webpage}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              click here{" "}
                            </a>
                          ) : (
                            ""
                          )}
                          {data?.gift_in_kind_email ? "or" : ""}
                          {data?.gift_in_kind_email ? (
                            <a
                              href={`mailto:${data.gift_in_kind_email}`}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              email
                            </a>
                          ) : (
                            ""
                          )}
                        </ParagraphComp>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {/* Purchase */}
                <Grid
                  item
                  className="max-sm:border-none border-r-[1px] border-black"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                  xs={12}
                  lg={4}
                  md={4}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Box
                      sx={{
                        height: "70px",
                        borderRadius: "100%",
                        width: "70px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        flexShrink: 0,
                      }}
                    >
                      {data?.purchase_icon ? (
                        <img
                          src={`data:image/png;base64,${data.purchase_icon}`}
                          width={48}
                          height={48}
                          alt="purchase icon"
                        />
                      ) : null}
                    </Box>
                    <Box sx={{ width: "70%", color: "#004878" }}>
                      <ParagraphComp
                        text="Purchase"
                        className="text-[#004878] text-2xl font-bold"
                      />
                      <ParagraphComp
                        text="When you buy a product from an NPO, you change one or more lives!"
                        className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal"
                      />
                      <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                        Item(s):{" "}
                        {data?.purchase_article1
                          ? `${data.purchase_article1}, `
                          : "-"}
                        {data?.purchase_article2
                          ? `${data.purchase_article2}, `
                          : ""}
                        {data?.purchase_article3
                          ? `${data.purchase_article3}, `
                          : ""}
                      </ParagraphComp>
                      {data?.purchase_email && (
                        <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                          To buy from the org,
                          {data?.purchase_webpage ? (
                            <a
                              href={data.purchase_webpage}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              click here{" "}
                            </a>
                          ) : (
                            ""
                          )}
                          {data?.purchase_email ? "or" : ""}
                          {data?.purchase_email ? (
                            <a
                              href={`mailto:${data.purchase_email}`}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              email
                            </a>
                          ) : (
                            ""
                          )}
                        </ParagraphComp>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {/* Celebrate */}
                <Grid
                  item
                  className="max-sm:border-none border-r-[1px] border-black"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                  xs={12}
                  lg={4}
                  md={4}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Box
                      sx={{
                        height: "70px",
                        borderRadius: "100%",
                        width: "70px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        flexShrink: 0,
                      }}
                    >
                      {data?.celebrate_icon ? (
                        <img
                          src={`data:image/png;base64,${data.celebrate_icon}`}
                          width={48}
                          height={48}
                          alt="celebrate icon"
                        />
                      ) : null}
                    </Box>
                    <Box sx={{ width: "70%" }}>
                      <ParagraphComp
                        text="Celebrate Occasions/ Events/ Visit)"
                        className="text-[#004878] text-2xl font-bold"
                      />
                      <ParagraphComp
                        text="Make your special days memorable by sharing your joy with communities!"
                        className="text-md mt-2 text-[#004878] leading-normal"
                      />
                      <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                        Details: {data?.celebrate_event || "-"}
                      </ParagraphComp>
                      {data?.celebrate_email && (
                        <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                          To learn more ,
                          {data?.celebrate_webpage ? (
                            <a
                              href={data.celebrate_webpage}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              click here{" "}
                            </a>
                          ) : (
                            ""
                          )}
                          {data?.celebrate_email ? "or" : ""}
                          {data?.celebrate_email ? (
                            <a
                              href={`mailto:${data.celebrate_email}`}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              email
                            </a>
                          ) : (
                            ""
                          )}
                        </ParagraphComp>
                      )}
                    </Box>
                  </Box>
                </Grid>

                {/* Participate in */}
                <Grid
                  item
                  className="max-sm:border-none border-r-[1px] border-black"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                  xs={12}
                  lg={4}
                  md={4}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "start",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                    <Box
                      sx={{
                        height: "70px",
                        borderRadius: "100%",
                        width: "70px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        flexShrink: 0,
                      }}
                    >
                      {data?.participate_in_icon ? (
                        <img
                          src={`data:image/png;base64,${data.participate_in_icon}`}
                          width={48}
                          height={48}
                          alt="participate icon"
                        />
                      ) : null}
                    </Box>
                    <Box sx={{ width: "70%" }}>
                      <ParagraphComp
                        text="Participate in"
                        className="text-[#004878] text-2xl font-bold"
                      />
                      <ParagraphComp
                        text="Participate in events and campaigns to make your contribution make a bigger difference!"
                        className="text-md mt-2 text-[#004878] leading-normal"
                      />
                      <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 text-[#004878] leading-normal">
                        Details: {data?.participate_make_difference || "-"}
                      </ParagraphComp>
                      {data?.participate_email ? (
                        <ParagraphComp className="text-lg max-sm:text-[14px] mt-2 leading-normal text-[#004878]">
                          To learn how you can participate in,
                          {data?.participate_webpage ? (
                            <a
                              href={data.participate_webpage}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              click here{" "}
                            </a>
                          ) : (
                            ""
                          )}
                          {data?.participate_email ? "or" : ""}
                          {data?.participate_email ? (
                            <a
                              href={`mailto:${data.participate_email}`}
                              className="text-[#0697e6] cursor-pointer"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              email
                            </a>
                          ) : (
                            ""
                          )}
                        </ParagraphComp>
                      ) : (
                        <ParagraphComp
                          text=""
                          className="text-md mt-2 text-[#004878] leading-normal"
                        />
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <ParagraphComp
                text="Not applicable, yet to qualify for support"
                className="text-md mt-4 pr-5"
              />
            )}
            <ParagraphComp
              text="*GuideStar India is only presenting information shared by the organisation without any verification. You would be transacting with the organisation or its intermediaries and using their payment channels as per their terms and conditions."
              className="text-md mt-4 text-[#004878] pr-5"
            />
          </Box>
        </Grid>
      </Grid>

      {/* ====== COLLABORATIONS ====== */}
      {data?.collaboration_government ||
      data?.collaboration_coorporates ||
      data?.collaboration_npo ||
      data?.network1 ||
      data?.network2 ||
      data?.network3 ? (
        <Grid item xs={12} sx={{ marginTop: "20px" }}>
          <Box
            sx={{
              width: "100%",
              borderRadius: "16px",
              padding: "16px",
              border: ".5px solid #004878",
            }}
          >
            <ParagraphComp
              text="Collaborations"
              className="text-[#004878] text-2xl mb-2 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            <Box sx={{ mt: 1 }}>
              <ParagraphComp
                text="with Government:"
                className="text-black text-md "
              />
              <ParagraphComp
                text={data?.collaboration_government || "-"}
                className="text-md mt-2 text-[#004878]"
              />
            </Box>
            <Box sx={{ mt: 1 }}>
              <ParagraphComp
                text="with Corporates:"
                className="text-black text-md "
              />
              <ParagraphComp
                text={data?.collaboration_coorporates || "-"}
                className="text-md mt-2 text-[#004878]"
              />
            </Box>
            <Box sx={{ mt: 1 }}>
              <ParagraphComp
                text="with NPOs:"
                className="text-black text-md "
              />
              <ParagraphComp
                text={data?.collaboration_npo || "-"}
                className="text-md mt-2 text-[#004878]"
              />
            </Box>
            <ParagraphComp
              text="Networks"
              className="text-[#004878] text-2xl mb-2 mt-3 font-bold"
            />
            <Divider sx={{ color: "#E5E8EB", borderBottomWidth: 3 }} />
            <Box sx={{ mt: 1 }}>
              <ParagraphComp
                text="Member of:"
                className="text-black text-md "
              />
              <ParagraphComp
                text={data?.network1 ?? ""}
                className="text-md mt-2 text-[#004878]"
              />
              <ParagraphComp
                text={data?.network2 ?? ""}
                className="text-md mt-2 text-[#004878]"
              />
              <ParagraphComp
                text={data?.network3 ?? ""}
                className="text-md mt-2 text-[#004878]"
              />
            </Box>
          </Box>
        </Grid>
      ) : null}
    </div>
  );
}

export default Summary;
